<template>

  <div class="page">
    <div class="top"></div>
    <div class="main">
      <div class="btn btn-1" @click="game">
        <div class="gka-wrap-game">
            <div id="gka1" class="animation"></div>
        </div>
      </div>

      <div class="btn btn-2" @click="prize">
        <div class="gka-wrap-prize">
            <div id="gka2" class="animation"></div>
        </div>
      </div>

      <div class="btn btn-3" @click="live">
        <div class="gka-wrap-live">
            <div id="gka3" class="animation"></div>
        </div>
      </div>

      <div class="btn btn-4">
        <div class="gka-wrap-details">
          <div id="gka4" class="animation"></div>
        </div>
        <wx-open-launch-weapp
          id="launch-btn"
          username="gh_05d056b5f467"
          path="pages/home/dashboard/index.html"
          style="position:absolute;top:0;left:0;width:100%;height:100%;"
        >
          <script type="text/wxtag-template">
            <div style="position:absolute;top:0;left:0;width:100%;height:100%;opacity:0;" />
          </script>
        </wx-open-launch-weapp>
      </div>
    </div>
    <div class="footer"></div>
  </div>

</template>

<script>
export default {
  props: [],
  data() {
    return {
    };
  },
  mounted() {
    // let _this = this
    // setTimeout(function(){
    //   _this.next();
    // },100000);
    // this.setTime();
  },
  methods: {
    game() {
      this.$emit("bindStart",'game');
    },
    prize() {
      this.$emit("bindStart",'prize');
    },
    live() {
      this.$emit("bindStart",'live');
    },
    details() {
      this.$emit("bindStart",'details');
    }
  },
};
</script>

<style scoped lang="less">
.page {
  height: 100vh;
  background: url("../images/bg.png") left bottom no-repeat;
  background-size: 750px 1500px;
  position: relative;
  overflow: hidden;
}
.top {
  position: absolute;
  top: 0;
  // bottom: 80%;
  width: 751px;
  height: 233px;
  background: url("../images/title.png") no-repeat;
  background-size: 100%;
}
.footer {
  position: absolute;
  width: 295px;
  height: 46px;
  left: 0;
  right: 0;
  bottom: 91px;
  margin: 0 auto;
  background: url("../images/icon-footer.png") no-repeat;
  background-size: 100%;
}
.main {
  position: absolute;
  width: 587px;
  height: 977px;
  left: 0;
  right: 0;
  // bottom: 224px;
  bottom: 12%;
  margin: 0 auto;
  box-sizing: border-box;
  background: url("../images/bg/index-bg.png") no-repeat;
  background-size: 100%;
  // display: flex;
  // align-items: flex-end;
  // justify-content: space-between;
  .btn {
    // width: 343px;
    // height: 211px;
    // 63.5
    // 42
    width: 216px;
    height: 127px;
    position: absolute;
    // border: 1px solid red;
  }
  .btn-1 {
    // left: 176px;
    // top: 18px;
    left: 239.5px;
    top: 60px;
  }
  .btn-2 {
    // left: 19px;
    // top: 272px;
    left: 82.5px;
    top: 314px;
  }
  .btn-3 {
    // left: 220px;
    // top: 501px;
    left: 283.5px;
    top: 553px;
  }
  .btn-4 {
    // left: 29px;
    // top: 737px;
    left: 92.5px;
    top: 779px;
    position: relative;
  }
  
  .gka-wrap-game {
    width: 216px;
    height: 127px;
    border-radius: 5px;
    .animation {
      width: 216px;
      height: 127px;
      background-image: url("../assets/sprites-GAME.jpg");
      background-size: 7992px 127px;
      background-repeat: no-repeat;
      animation-name: keyframes-GAME;
      animation-duration: 1.48s;
      animation-delay: 0s;
      animation-iteration-count: infinite;
      animation-fill-mode: forwards;
      animation-timing-function: steps(1);
    }
  }
  .gka-wrap-prize {
    width: 216px;
    height: 127px;
    .animation {
      width: 216px;
      height: 127px;
      background-image: url("../assets/sprites-PRIZE.jpg");
      background-size: 5616px 127px;
      background-repeat: no-repeat;
      animation-name: keyframes-PRIZE;
      animation-duration: 1.04s;
      animation-delay: 0s;
      animation-iteration-count: infinite;
      animation-fill-mode: forwards;
      animation-timing-function: steps(1);
    }
  }
  .gka-wrap-live {
    width: 216px;
    height: 127px;
    .animation {
      width: 216px;
      height: 127px;
      background-image: url("../assets/sprites-LIVE.jpg");
      background-size: 11232px 127px;
      background-repeat: no-repeat;
      animation-name: keyframes-LIVE;
      animation-duration: 2.08s;
      animation-delay: 0s;
      animation-iteration-count: infinite;
      animation-fill-mode: forwards;
      animation-timing-function: steps(1);
    }
  }
  .gka-wrap-details {
      width: 217px;
      height: 127px;
      // position: absolute;
      // z-index: 1;
      // top: 0;
      // left: 0;
    .animation {
      width: 217px;
      height: 127px;
      background-image: url("../assets/sprites-DETALS.jpg");
      background-size: 6076px 127px;
      background-repeat: no-repeat;
      animation-name: keyframes-DETALS;
      animation-duration: 1.12s;
      animation-delay: 0s;
      animation-iteration-count: infinite;
      animation-fill-mode: forwards;
      animation-timing-function: steps(1);
    }
  }

}
</style>